import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from '@redux';
import { cancelTransferOrders } from '@redux/transferOrders/actions';
import { Button, Modal } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DynamicObjectType } from 'types/commons';

const CancelModal = ({ onCancel }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const currentData = useSelector<DynamicObjectType>(
    (state) => state.transferOrders.currentData,
  );
  const modal = useSelector<DynamicObjectType>((state) => state.modal.modal);

  const [loading, setLoading] = useState(false);

  const handleCancel = async () => {
    setLoading(true);
    try {
      await dispatch(
        cancelTransferOrders({
          data: {
            id: currentData?.id,
          },
          options: {
            isShowSuccessNoti: true,
          },
        }),
      ).then((res: DynamicObjectType) => {
        if (res?.payload?.success) {
          setLoading(false);
          onCancel();
          window.location.reload();
        }
        setLoading(false);
      });
    } catch {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={modal?.cancel?.isOpen}
      onCancel={onCancel}
      footer={null}
      width={443}
      closeIcon={false}
      closable={false}
    >
      <div className="grid gap-5">
        <div className="text-center text-[24px]">
          <FontAwesomeIcon
            icon={faCircleExclamation}
            className="text-[--primary] mb-[5px]"
          />
          <div className="text-center text-base font-semibold">
            {t('transferOrders.confrimCancel')}
          </div>
        </div>
        <div className="text-center text-[#53575D] text-sm">
          {t('transferOrders.confrimCancelDescription')}
        </div>
        <div className="flex justify-center items-center gap-2.5">
          <Button className="h-[40px] w-[100px]" onClick={onCancel}>
            {t('button.cancel')}
          </Button>
          <Button
            className="h-[40px] w-[100px]"
            type="primary"
            onClick={handleCancel}
            loading={loading}
          >
            {t('button.ok')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CancelModal;
